import { render, staticRenderFns } from "./ShortVideoManagement.vue?vue&type=template&id=745cd133&scoped=true"
import script from "./ShortVideoManagement.vue?vue&type=script&lang=js"
export * from "./ShortVideoManagement.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoManagement.vue?vue&type=style&index=0&id=745cd133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745cd133",
  null
  
)

export default component.exports